import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

const Auth = ({ children }) => {
    const { token } = useSelector((state) => state.auth)

    const isAuthenticated = !!token

    return isAuthenticated ? children : <Navigate to={"/authentication/sign-in"} />
}

export default Auth